"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scanner = void 0;
var Token_1 = require("./Token");
var ROW_DELIMITER = /((?:\r\n)|\n|\r)/;
var Scanner = /*#__PURE__*/function () {
  function Scanner(args) {
    _classCallCheck(this, Scanner);
    this.cursor = 0;
    this.line = args.line;
    this.lineLength = this.line.length;
    this.parserOptions = args.parserOptions;
    this.hasMoreData = args.hasMoreData;
    this.cursor = args.cursor || 0;
  }
  _createClass(Scanner, [{
    key: "hasMoreCharacters",
    get: function get() {
      return this.lineLength > this.cursor;
    }
  }, {
    key: "nextNonSpaceToken",
    get: function get() {
      var lineFromCursor = this.lineFromCursor;
      var regex = this.parserOptions.NEXT_TOKEN_REGEXP;
      if (lineFromCursor.search(regex) === -1) {
        return null;
      }
      var match = regex.exec(lineFromCursor);
      if (match == null) {
        return null;
      }
      var token = match[1];
      var startCursor = this.cursor + (match.index || 0);
      return new Token_1.Token({
        token: token,
        startCursor: startCursor,
        endCursor: startCursor + token.length - 1
      });
    }
  }, {
    key: "nextCharacterToken",
    get: function get() {
      var cursor = this.cursor,
        lineLength = this.lineLength;
      if (lineLength <= cursor) {
        return null;
      }
      return new Token_1.Token({
        token: this.line[cursor],
        startCursor: cursor,
        endCursor: cursor
      });
    }
  }, {
    key: "lineFromCursor",
    get: function get() {
      return this.line.substr(this.cursor);
    }
  }, {
    key: "advancePastLine",
    value: function advancePastLine() {
      var match = ROW_DELIMITER.exec(this.lineFromCursor);
      if (!match) {
        if (this.hasMoreData) {
          return null;
        }
        this.cursor = this.lineLength;
        return this;
      }
      this.cursor += (match.index || 0) + match[0].length;
      return this;
    }
  }, {
    key: "advanceTo",
    value: function advanceTo(cursor) {
      this.cursor = cursor;
      return this;
    }
  }, {
    key: "advanceToToken",
    value: function advanceToToken(token) {
      this.cursor = token.startCursor;
      return this;
    }
  }, {
    key: "advancePastToken",
    value: function advancePastToken(token) {
      this.cursor = token.endCursor + 1;
      return this;
    }
  }, {
    key: "truncateToCursor",
    value: function truncateToCursor() {
      this.line = this.lineFromCursor;
      this.lineLength = this.line.length;
      this.cursor = 0;
      return this;
    }
  }]);
  return Scanner;
}();
exports.Scanner = Scanner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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